"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scanner = void 0;
var Token_1 = require("./Token");
var ROW_DELIMITER = /((?:\r\n)|\n|\r)/;
var Scanner = /*#__PURE__*/function () {
  function Scanner(args) {
    _classCallCheck(this, Scanner);
    this.cursor = 0;
    this.line = args.line;
    this.lineLength = this.line.length;
    this.parserOptions = args.parserOptions;
    this.hasMoreData = args.hasMoreData;
    this.cursor = args.cursor || 0;
  }
  _createClass(Scanner, [{
    key: "hasMoreCharacters",
    get: function get() {
      return this.lineLength > this.cursor;
    }
  }, {
    key: "nextNonSpaceToken",
    get: function get() {
      var lineFromCursor = this.lineFromCursor;
      var regex = this.parserOptions.NEXT_TOKEN_REGEXP;
      if (lineFromCursor.search(regex) === -1) {
        return null;
      }
      var match = regex.exec(lineFromCursor);
      if (match == null) {
        return null;
      }
      var token = match[1];
      var startCursor = this.cursor + (match.index || 0);
      return new Token_1.Token({
        token: token,
        startCursor: startCursor,
        endCursor: startCursor + token.length - 1
      });
    }
  }, {
    key: "nextCharacterToken",
    get: function get() {
      var cursor = this.cursor,
        lineLength = this.lineLength;
      if (lineLength <= cursor) {
        return null;
      }
      return new Token_1.Token({
        token: this.line[cursor],
        startCursor: cursor,
        endCursor: cursor
      });
    }
  }, {
    key: "lineFromCursor",
    get: function get() {
      return this.line.substr(this.cursor);
    }
  }, {
    key: "advancePastLine",
    value: function advancePastLine() {
      var match = ROW_DELIMITER.exec(this.lineFromCursor);
      if (!match) {
        if (this.hasMoreData) {
          return null;
        }
        this.cursor = this.lineLength;
        return this;
      }
      this.cursor += (match.index || 0) + match[0].length;
      return this;
    }
  }, {
    key: "advanceTo",
    value: function advanceTo(cursor) {
      this.cursor = cursor;
      return this;
    }
  }, {
    key: "advanceToToken",
    value: function advanceToToken(token) {
      this.cursor = token.startCursor;
      return this;
    }
  }, {
    key: "advancePastToken",
    value: function advancePastToken(token) {
      this.cursor = token.endCursor + 1;
      return this;
    }
  }, {
    key: "truncateToCursor",
    value: function truncateToCursor() {
      this.line = this.lineFromCursor;
      this.lineLength = this.line.length;
      this.cursor = 0;
      return this;
    }
  }]);
  return Scanner;
}();
exports.Scanner = Scanner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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